import axioPath from "api/axioPath";
import { UPDATE_DATA } from "redux/actions/action_types";

export const orderList = (data, customerId, token) => (dispatch) => {
  return axioPath.post(`/order/order_list/${customerId}`, data, {
    headers: {
      Authorization: `${token}`,
      UserType: "external"
    },
  })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data, apiType: "form" });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};

export const cancelOrderApiCall = (locationType, customerId, token, referenceId, comment) => (dispatch) => {
  // return axioPath.post(`/order/${customerId}/cancel_order/${orderId}`, {
  let data = {
    customerId: customerId,
    refNo: referenceId,
    comment: comment,
    locationType
  }
  return axioPath.post(`/order/cancel_order`, data, {
    headers: {
      Authorization: `${token}`,
      UserType: "external"
    },
  })
    .then((response) => {
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      if (typeof ex == "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};
